var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",attrs:{"id":"layout"}},[_c('el-container',{staticClass:"container1"},[_c('el-header',{ref:"header"},[_c('headerCon')],1),_vm._v(" "),_c('el-main',[_c('router-view')],1),_vm._v(" "),_c('el-footer',{staticStyle:{"padding":"0"},attrs:{"id":"footer"}},[_c('footerCon')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd0d501c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main.vue
// module id = null
// module chunks = 